import { useTranslation } from 'react-i18next';
import { IInitialState } from '../../../../../reduxService';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { IProjectMacra1 } from '../../../../MACRA_1/store/project/projectSlice';
import { fetchProjectResults } from '../../../../MACRA_1/store/project/resultsSlice';
import { IProjectMacra2 } from '../../../../MACRA_2/store/project/projectSlice';
import { fetchSlopedProjectResults, fetchSteppedProjectResults, fetchVerticalProjectResults } from '../../../../MACRA_2/store/project/resultsSlice';
import { getActionByProjectType } from '../../../../actionMap';
import { EProjectType } from '../../../../enum/project';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { saveProject } from '../../../../utils/utils';
import { IRunButtonProps } from './IRunButton';
import './RunButton.scss';
import { useParams } from 'react-router-dom';

const RunButton = (props: IRunButtonProps) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const projectInfo = useAppSelector(selectProjectInfo);
    const { selectProject } = getActionByProjectType();
    const { id } = useParams();

    const project: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProject as any);

    const handleSaveCloud = async () => {
        let pInfo = projectInfo.data!;
        let idForSave = projectInfo.data?.id ? projectInfo.data.id : !!id ? parseInt(id) : undefined;
        await saveProject({ ...pInfo, id: idForSave }, true);
    };
    const handleClick = async () => {
        handleSaveCloud();
        switch (projectInfo.data?.type) {
            case EProjectType.Macra2 | EProjectType.SlopedWeir:
                dispatch(fetchSlopedProjectResults());
                break;
            case EProjectType.Macra2 | EProjectType.SteppedWeir:
                dispatch(fetchSteppedProjectResults());
                break;
            case EProjectType.Macra2 | EProjectType.VerticalDrop:
                dispatch(fetchVerticalProjectResults());
                break;
            default:
                dispatch(fetchProjectResults());
                break;
        }
    };
    return (
        <button id='run' type='button' className={`px-4 py-2 d-flex align-items-center gap-3 ${props.className}`} onClick={handleClick}>
            <i className='fa-solid fa-play' /> {t('header_run_button')}
        </button>
    );
};

export default RunButton;
